module.exports = __webpack_public_path__ + "img/chevron-right.3b1ffa09.svg";